module.exports = __webpack_public_path__ + "static/media/filled_bar_WPC_tall.5d9dd929.svg";